import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { collapseTextChangeRangesAcrossMultipleVersions } from 'typescript';
import { ApiService } from '../../api/api.service';
import { FormactionService } from '../../api/formaction.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-eriform-edit',
  templateUrl: './eriform-edit.component.html',
  styleUrls: ['./eriform-edit.component.css']
})
export class EriformEditComponent implements OnInit {


  public trackId_candidate_email: string = '';
  public trackId_invigi_email: string = '';
  public trackId_name: string = ' ';
  public trackId_refno: string = ' ';
  public trackId_regno: string = ' ';
  public trackId_iticode: string = ' ';
  public trackId_trade: string = ' ';
  public trackId_state: string = ' ';
  public trackId_district: string = ' ';
  public trackId_date: string = ' ';
  public trackId_shift: string = ' ';
  public trackId_attendance: string = ' ';
  public trackId_status: string = ' ';
  public trackId_ntef: string = ' ';
  public trackId_issuedetail: string = ' ';
  public trackId_description: string = ' ';

  submitted = false;
  public eriStatusForm: any;

  constructor(private formBuilder: FormBuilder, private api: ApiService, private formaction: FormactionService, private router: Router) { }


  ngOnInit(): void {

    this.eriStatusForm = this.formBuilder.group({
      refno: [''],
      email: [''],
      candidateemail: [''],
      status: ['', Validators.required],
      statusDescription: ['', Validators.required]
    });



    this.formaction.get_eriList_single().subscribe((result: any) => {
      var args = {
        eriNo: result.refno
      }




      this.api.updateeri(args).subscribe((result: any) => {

        console.log("Eri list" + JSON.stringify(result));
        this.trackId_candidate_email = result.candidateemail;
        this.trackId_invigi_email = result.email;
        this.trackId_name = result.username;
        this.trackId_refno = result.refno;
        this.trackId_regno = result.regno;
        this.trackId_iticode = result.iticode;
        this.trackId_trade = result.trade;
        this.trackId_state = result.state;
        this.trackId_district = result.district;
        this.trackId_date = result.date;
        this.trackId_shift = result.shift;
        this.trackId_attendance = result.attendance;
        this.trackId_status = result.status;
        this.trackId_ntef = result.ntef;
        this.trackId_issuedetail = result.issuedetail;
        this.trackId_description = result.description;




        //  'refno: "ERI21000082", state: "KERALA", district: "THIRUVANANTHAPURAM", iticode: "CFI3200001", attendance: "Present" date: "28-12-2020" description: ""district: "THIRUVANANTHAPURAM" issuedetail: "Internet Failure during Exam" ntef: "Exam Incomplete" regno: "190832035020" shift: "First"  status: "submitted" trade: "Additive Manufacturing Technician Three D Print" username: "VAISHNAVI P S'

        //   if(result.status == 'fail'){
        //     alert("Enter Correct Eri Number")
        //     return;
        //   }
        //   else{
        //     this.submitted = false;

        //     this.bool_intruc_main = false;
        //     this.bool_issue_type = true;

        //     this.examFormloginBoolean = false;


        //     this.bool_trackComp = true;
        //   }
      });



    });



  }

  get f() { return this.eriStatusForm.controls; }

  onSubmit() {
    this.eriStatusForm.controls["refno"].setValue(this.trackId_refno);
    this.eriStatusForm.controls["email"].setValue(this.trackId_invigi_email);
    this.eriStatusForm.controls["candidateemail"].setValue(this.trackId_candidate_email);


    // var a = this.eriStatusForm.controls["refno"] = this.trackId_refno;
    // this.eriStatusForm.controls["refno"].push('123')

    this.submitted = true;

    if (this.eriStatusForm.invalid) {
      return;
    }

    this.api.eristatus(this.eriStatusForm.value).subscribe((result: any) => {
      console.log(result)
    })

    alert("Grievance status updated successfully");
    window.scroll(0, 0);
    this.router.navigate(['/dashboard/erilist']);

  }
  omit_spl(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 47 || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }


}
